import { cx } from '@emotion/css';
import Box from '@mui/material/Box';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { ix } from '../../../../utils/ix';
import { LightweightFilterMenu } from '../LightweightFilterMenu';
import { DEFAULT_FILTER_OPTIONS, DEFAULT_MAX_FILTERED_FIELD_NAMES } from './LightweightFilters.constants';
import { useStyles } from './LightweightFilters.styles';
import { AddFilterMenu } from './components/AddFilterMenu';
export const LightweightFilters = memo(({ id, className, fieldNames, operators, value, onChange, defaultOperatorValue, maxFilteredFieldNames = DEFAULT_MAX_FILTERED_FIELD_NAMES, noWrapper = false, size, }) => {
    const classes = useStyles();
    const [recentlyAddedFilter, setRecentlyAddedFilter] = useState();
    const notSelectedFiledNameOptions = useMemo(() => {
        return fieldNames
            .map((fieldName) => fieldName.fieldNameOption)
            .filter((option) => !Object.keys(value).includes(option.value));
    }, [fieldNames, value]);
    const filterOptions = useMemo(() => {
        return fieldNames.reduce((previousValue, currentValue) => (Object.assign(Object.assign({}, previousValue), { [currentValue.fieldNameOption.value]: {
                hideSelectAll: currentValue.hideSelectAll,
                isLoading: currentValue.isLoading,
                label: currentValue.fieldNameOption.label,
                filterOptions: currentValue.filterOptions,
                disableRemove: currentValue.disableRemove,
                operatorOptionsOverride: currentValue.operatorOptionsOverride,
            } })), {});
    }, [fieldNames]);
    const handleFilterAdd = useCallback((fieldNameOption) => {
        const newFilter = { operator: defaultOperatorValue, values: [] };
        setRecentlyAddedFilter(fieldNameOption.value);
        onChange(Object.assign(Object.assign({}, value), { [fieldNameOption.value]: newFilter }), fieldNameOption.value);
    }, [defaultOperatorValue, onChange, value]);
    const handleChange = useCallback((values, operator, fieldName) => {
        if (!value[fieldName]) {
            return;
        }
        const updatedValue = Object.assign({}, value);
        updatedValue[fieldName].values = values;
        updatedValue[fieldName].operator = operator;
        onChange(updatedValue, fieldName);
    }, [onChange, value]);
    const handleRemove = useCallback((fieldName) => {
        if (!value[fieldName]) {
            return;
        }
        const updatedValue = Object.assign({}, value);
        delete updatedValue[fieldName];
        onChange(updatedValue, fieldName);
    }, [value, onChange]);
    const showAddFilter = Object.keys(value).length < maxFilteredFieldNames;
    const content = (React.createElement(React.Fragment, null,
        Object.entries(value).map(([fieldName, filter]) => {
            var _a, _b, _c, _d, _e, _f;
            return (React.createElement(LightweightFilterMenu, { id: ix(id, 'lightweight-filter-menu', fieldName), key: fieldName, fieldName: fieldName, hideSelectAll: (_a = filterOptions[fieldName]) === null || _a === void 0 ? void 0 : _a.hideSelectAll, isLoading: ((_b = filterOptions[fieldName]) === null || _b === void 0 ? void 0 : _b.isLoading) || false, label: ((_c = filterOptions[fieldName]) === null || _c === void 0 ? void 0 : _c.label) || fieldName, operatorOptions: ((_d = filterOptions[fieldName]) === null || _d === void 0 ? void 0 : _d.operatorOptionsOverride) || operators, onChange: handleChange, operator: filter.operator, options: ((_e = filterOptions[fieldName]) === null || _e === void 0 ? void 0 : _e.filterOptions) || DEFAULT_FILTER_OPTIONS, values: filter.values, onRemove: ((_f = filterOptions[fieldName]) === null || _f === void 0 ? void 0 : _f.disableRemove) ? undefined : handleRemove, isInitiallyOpen: fieldName === recentlyAddedFilter, size: size }));
        }),
        showAddFilter && (React.createElement(AddFilterMenu, { id: ix(id, 'add-filter'), fieldNameOptions: notSelectedFiledNameOptions, onClick: handleFilterAdd }))));
    return noWrapper ? (content) : (React.createElement(Box, { id: id, className: cx(className, classes.root) }, content));
});
//# sourceMappingURL=LightweightFilters.js.map